/** Pure geometry for rotateAssetPhoto. */

/** Clamp an accumulated rotation to one of 0 / 90 / 180 / 270. */
export function normalizeRotation(degrees: number): number {
  return ((Math.round(degrees / 90) * 90) % 360 + 360) % 360;
}

/**
 * Canvas size needed to hold `width`×`height` rotated by `degrees`.
 *
 * A 90°/270° turn swaps the axes, so a canvas left at the source dimensions
 * would crop the long edge.
 */
export function rotatedCanvasSize(
  width: number,
  height: number,
  degrees: number,
): { width: number; height: number } {
  const radians = (normalizeRotation(degrees) * Math.PI) / 180;
  const sin = Math.abs(Math.sin(radians));
  const cos = Math.abs(Math.cos(radians));
  return {
    width: Math.round(width * cos + height * sin),
    height: Math.round(width * sin + height * cos),
  };
}
